(function () {

    'use strict';

    angular.module('iplusjs.fileupload', [
        'ngMessages',
        'lodash',
        'iplusjs.config',
        'iplusjs.utils.binary',
        'iplusjs.utils.device',
        'iplusjs.validator.form',
        'iplusjs.validationMessage',
        'iplusjs.utils.misc'
    ])
        .component('iplusjsFileUpload', {
            bindings: {
                accept: '@ifuAccept',
                disabled: '<ngDisabled',
                multiple: '@ifuMultiple',
                maxFileSize: '@ifuMaxFilesize',
                maxFileSizeAll: '@ifuMaxFilesizeAll',
                maxFileCount: '@ifuMaxFilecount',
                onUpload: '&ifuOnUpload',
                onShow: '&ifuOnShow',
                onDelete: '&ifuOnDelete',
                chooseBtnText: '@ifuChooseBtnText',
                uploadBtnText: '@ifuUploadBtnText',
                resetBtnText: '@ifuResetBtnText',
                chooseBtnMultipleText: '@ifuChooseBtnMultipleText',
                uploadBtnMultipleText: '@ifuUploadBtnMultipleText',
                uploadedFiles: '<ifuFiles',
                errorMimeType: '@ifuErrorMimeType',
                options: '<ifuOptions'
            },
            templateUrl: 'common/fileupload/fileupload.html',
            controller: FileUploadController,
            controllerAs: 'fileUploadVm'
        })
        .directive('iplusjsFileMultiple', fileMultiple)
        .service('FileUploadService', FileUploadService);

    fileMultiple.$inject = [];

    function fileMultiple() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function ($scope, $element, $attrs, $ctrl) {
                var multiple = $attrs.iplusjsFileMultiple === 'true' ? true : false;

                if (multiple) {
                    $element.attr('multiple', 'multiple');
                }
            }
        };
    }

    FileUploadController.$inject = [
        '$scope',
        'numbro',
        '$element',
        'lodash',
        'MiscUtilsService',
        'BinaryUtilsService',
        'DeviceUtilsService'
    ];
    function FileUploadController($scope, numbro, $element, _, MiscUtilsService, BinaryUtilsService, DeviceUtilsService) {
        var vm = this,
            chooseBtnText,
            uploadBtnText,
            resetBtnText,
            chooseBtnMultipleText,
            uploadBtnMultipleText;

        vm.onInputFileChange = onInputFileChange;
        vm.onInputFileFocus = onInputFileFocus;
        vm.onInputFileBlur = onInputFileBlur;
        vm.resetSelectedFiles = resetSelectedFiles;

        vm.uploadFiles = uploadFiles;
        vm.deleteFile = deleteFile;
        vm.showFile = showFile;
        vm.isUploadBtnDisabled = isUploadBtnDisabled;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;
        vm.$postLink = postLink;

        function activate() {
            chooseBtnText = vm.chooseBtnText || 'Datei auswählen';
            uploadBtnText = vm.uploadBtnText || 'Datei hochladen';
            resetBtnText = vm.resetBtnText || 'Zurücksetzen';
            chooseBtnMultipleText = vm.chooseBtnMultipleText || '{0} Dateien ausgewählt';
            uploadBtnMultipleText = vm.uploadBtnMultipleText || '{0} Dateien hochladen';

            vm.chooseBtnCaption = chooseBtnText;
            vm.uploadBtnCaption = uploadBtnText;
            vm.resetBtnCaption = resetBtnText;

            vm.acceptedMimeTypes = DeviceUtilsService.isIos() ? '' : vm.accept;
            vm.files = [];
            vm.fileUploadForm = vm.fileUploadForm || {};
            vm.inputHasFocus = false;
            vm.isAppModus = MiscUtilsService.isAppModus();

            vm.maxFileSize = parseInt(vm.maxFileSize, 10) || 0,
            vm.maxFileSizeAll = parseInt(vm.maxFileSizeAll, 10) || 0,
            vm.maxFileCount = parseInt(vm.maxFileCount, 10) || 0;

            vm.placeholders = {
                files: {
                    mimetype: [
                        vm.errorMimeType
                    ],
                    filesize: [
                        numbro(vm.maxFileSize).format('0 b').replace('MiB', 'MB').replace('KiB', 'KB').replace('GiB', 'GB')
                    ],
                    filesizeall: [
                        numbro(vm.maxFileSizeAll).format('0 b').replace('MiB', 'MB').replace('KiB', 'KB').replace('GiB', 'GB')
                    ],
                    filecount: [
                        vm.maxFileCount
                    ]
                }
            };
        }

        function onInit() {
            activate();
        }

        function onChanges(changes) {
            activate();
            if (vm.ngModelCtrl) {
                vm.ngModelCtrl.$validate();
            }
        }

        function postLink() {
            var inputFileEl = $element.find('input'),
                ngModelCtrl = inputFileEl.controller('ngModel');

            vm.options = vm.options || {};

            vm.ngModelCtrl = ngModelCtrl;

            inputFileEl.bind('change', onInputFileChange);
            ngModelCtrl.$validators.filesize = function (files) {
                if (!vm.maxFileSize) {
                    return true;
                }

                var hasLargeFiles = !!_.filter(files, function (file) {
                    return file.size > vm.maxFileSize;
                }).length;

                if (hasLargeFiles) {
                    return false;
                }

                return true;
            };
            ngModelCtrl.$validators.filesizeall = function (files) {
                var fileSizeAll = 0;
                if (!vm.maxFileSizeAll) {
                    return true;
                }

                _.forEach(files, function (file) {
                    fileSizeAll += file.size || 0;
                });

                if (fileSizeAll > vm.maxFileSizeAll) {
                    return false;
                }

                return true;
            };
            ngModelCtrl.$validators.filecount = function (files) {
                var filesCount = vm.uploadedFiles.length + (files || []).length;
                if (!vm.maxFileCount) {
                    return true;
                }
                if (vm.uploadedFiles.length > filesCount) {
                    return true;
                }

                if (filesCount > vm.maxFileCount && (files || []).length) {
                    return false;
                }

                return true;
            };
            ngModelCtrl.$validators.mimetype = function (files) {
                var acceptedMimeTypes = vm.accept.split(','),
                    isMimeTypeAccepted = false;

                if (!files || !files.length) {
                    return true;
                }

                _.forEach(files, function (file) {
                    isMimeTypeAccepted = BinaryUtilsService.checkMimeType(acceptedMimeTypes, file.type, BinaryUtilsService.getFileExtension(file.name));

                    if (!isMimeTypeAccepted) {
                        return false;
                    }
                });

                return isMimeTypeAccepted;
            };
            ngModelCtrl.$validators.required = function () {
                if (!vm.options.required || vm.disabled) {
                    return true;
                }

                return !!vm.uploadedFiles.length;
            };
        }
        function uploadFiles() {
            vm.onUpload({
                files: vm.files
            });
            resetSelectedFiles();
        }
        function deleteFile(file) {
            vm.onDelete({
                file: file
            });
        }
        function showFile(file) {
            vm.onShow({
                file: file
            });
        }
        function resetSelectedFiles() {
            if (vm.fileUploadForm && angular.isFunction(vm.fileUploadForm.$rollbackViewValue)) {
                vm.fileUploadForm.$rollbackViewValue();
            }
            vm.files = [];
            $element.find('input')[0].value = '';
            vm.chooseBtnCaption = chooseBtnText;
            vm.uploadBtnCaption = uploadBtnText;

            $scope.$applyAsync(function () {
                vm.ngModelCtrl.$validate();
            });
        }
        function isUploadBtnDisabled() {
            if (vm.options.required && _.size(vm.fileUploadForm.$error) === 1 && vm.fileUploadForm.$error.required && vm.files.length) {
                return false;
            }

            return vm.fileUploadForm.$invalid || vm.fileUploadForm.$pending || !vm.files.length;
        }
        function onInputFileChange(event) {
            $scope.$applyAsync(function () {
                var filesCount = 0;

                if (event && event.target) {
                    vm.files = event.target.files;
                } else {
                    vm.files = [];
                }

                filesCount = vm.files.length;

                if (!filesCount) {
                    vm.chooseBtnCaption = chooseBtnText;
                    vm.uploadBtnCaption = uploadBtnText;
                } else if (filesCount === 1) {
                    vm.chooseBtnCaption = vm.files[0].name;
                    vm.uploadBtnCaption = uploadBtnText;
                } else {
                    vm.chooseBtnCaption = chooseBtnMultipleText.replace('{0}', filesCount);
                    vm.uploadBtnCaption = uploadBtnMultipleText.replace('{0}', filesCount);
                }

                vm.ngModelCtrl.$validate();
            });
        }
        function onInputFileFocus() {
            vm.inputHasFocus = true;
        }
        function onInputFileBlur() {
            vm.inputHasFocus = false;
        }
    }

    FileUploadService.$inject = [
        '$log',
        '$q',
        'lodash',
        'AppConfig'
    ];
    function FileUploadService($log, $q, _, AppConfig) {
        var that = this;

        that.uploadDateien = uploadDateien;
        that.getErfolgreicheUploads = getErfolgreicheUploads;
        that.getFehlerhafteUploads = getFehlerhafteUploads;
        that.isBlocked = isBlocked;
        function uploadDateien(uploadPromises) {
            var uploadResult = []; // Speicher für erfolgreiche Uploads

            if (!uploadPromises || !uploadPromises.length) {
                return $q.reject('KEINE_UPLOADS');
            }

            return uploadPromises.reduce(function (previousPromise, promise) {
                var file;

                return previousPromise.then(function (result) {
                    return promise().then(function (response) {
                        file = response.config.file;
                        return uploadResult.push({
                            success: true,
                            data: response.data,
                            binary: file,
                            filename: file.name,
                            mimeType: file.type
                        });
                    }).catch(function (response) {
                        if (isBlocked(response)) {
                            return $q.reject(response);
                        }

                        file = response.config.file;
                        return uploadResult.push({
                            success: false,
                            data: response.data,
                            binary: file,
                            filename: file.name,
                            mimeType: file.type
                        });
                    });
                });
            }, $q.when()).then(function () {
                return uploadResult;
            }).catch(function (error) {
                return $q.reject(error);
            });
        }
        function getErfolgreicheUploads(uploadResult) {
            return _.filter(uploadResult, ['success', true]);
        }
        function getFehlerhafteUploads(uploadResult) {
            return _.filter(uploadResult, ['success', false]);
        }
        function isBlocked(responseError) {
            responseError = responseError || {};

            var regexDetectRules = _.get(AppConfig, 'APP.upload.icap.regexDetectRules') || {},
                blocked;

            if (_.isEmpty(regexDetectRules)) {
                return false;
            }

            blocked = _.every(regexDetectRules, function (val, key) {
                if (!_.isRegExp(val) || _.isEmpty(key)) {
                    return true;
                }

                return val.test(_.get(responseError, key));
            });

            return blocked;
        }
    }
})();
